import cx from 'classnames'
import Parser from 'html-react-parser'
import { useRef } from 'react'
import ReactDOMServer from 'react-dom/server'

import { Multi } from '../../igao/components/selects'
import { relationType } from '../../igao/utils'
import { Checkbox } from '../../shared/NarusMaterial'
import indexStyles from '../index.module.scss'

import styles from './igao.module.scss'
import SelectRelations from './select-relations'

const Igao = ({
  newItem,
  setNewItem,
  handleChange,
  handleOnKeyDown,
  data,
  page
}) => {
  const inputRef = useRef(null)
  const handleSelect = ({ id, key }) => {
    setNewItem({
      ...newItem,
      [key]: id
    })
  }

  const selected = data[page]?.lists?.domain?.find(d => d.id === newItem.domain)
    ? {
      ...data[page]?.lists?.domain?.find(d => d.id === newItem.domain),
      key: 'domain'
    }
    : undefined

  const issuePreview = () => {
    let preview = newItem.template
    data[page]?.lists?.relations?.map(rel => {
      preview = preview.replace(`{${rel.name}}`, () =>
        ReactDOMServer.renderToString(
          <Multi
            disabled
            type='multi-select'
            style={{ margin: '0 3px' }}
            relation={{
              type: relationType(rel.name),
              key: rel.name
            }}
            lists={data[page].lists}
          />
        ))
      return rel
    })
    return Parser(preview)
  }

  return (
    <div style={{ padding: '30px 0 10px 0' }}>
      <div
        style={{
          position: 'relative',
          padding: '0 30px'
        }}
      >
        <label htmlFor='template'>Issue Template</label>
        <input
          ref={inputRef}
          className={cx(indexStyles.input, indexStyles.template)}
          type='text'
          name='template'
          onKeyDown={e => handleOnKeyDown(e, inputRef, newItem, false)}
          onChange={e => handleChange('template', e.target.value)}
          value={newItem?.template || ''}
        />
        <SelectRelations
          lists={data[newItem?.page]?.lists || null}
          question={newItem}
          setQuestion={setNewItem}
          inputRef={inputRef}
        />
        {newItem.template?.length > 0 && (
          <div
            style={{
              paddingLeft: '12px',
              paddingRight: '12px',
              paddingTop: '9px',
              color: '#9a9797',
              overflowWrap: 'anywhere',
              display: 'flex',
              alignItems: 'center'
            }}
          >
            {issuePreview()}
          </div>
        )}
      </div>
      <div
        style={{
          margin: '18px 30px 0 30px',
          display: 'flex'
        }}
      >
        <div className={styles.domain}>
          <label htmlFor='multi-select'>Domain</label>
          <Multi
            id='multi-select'
            relative
            type='multi-select'
            relation={{
              key: 'domain',
              label: 'Domain'
            }}
            selectStyle={styles.domainSelect}
            lists={data[page].lists}
            itemId={newItem.id}
            disabled={false}
            handler={handleSelect}
            selected={selected}
          />
        </div>
        <div style={{ marginLeft: '16px' }}>
          <label htmlFor='checkboxes'>Unfavorable answer that triggers IGAO</label>
          <div
            style={{ padding: '6px 10px 14px 10px' }}
            id='checkboxes'
          >
            <Checkbox
              value={newItem?.unfavorable === 'yes'}
              label='Yes'
              round
              onChange={() => {
                handleChange('unfavorable', 'yes')
              }}
            />
            <Checkbox
              value={newItem?.unfavorable === 'no'}
              label='No'
              round
              onChange={() => {
                handleChange('unfavorable', 'no')
              }}
            />
          </div>
        </div>
      </div>
      <div style={{ margin: '18px 30px 0 30px' }}>
        <label htmlFor='goal'>Goal</label>
        <input
          style={{ marginBottom: '18px' }}
          onChange={e => handleChange('goal', e.target.value)}
          type='text'
          name='goal'
          value={newItem.goal || ''}
        />
      </div>
    </div>
  )
}

export default Igao
